import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-8 text-gray-500 flex flex-col items-center justify-center"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row items-center justify-start"
}
const _hoisted_3 = {
  key: 0,
  class: "rounded-full p-2 bg-primary w-8 mr-2"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-row items-center"
}
const _hoisted_6 = {
  key: 2,
  class: "truncate"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BudgetTableHeaders = _resolveComponent("BudgetTableHeaders")
  const _component_CardHeader = _resolveComponent("CardHeader")
  const _component_WarningIcon = _resolveComponent("WarningIcon")
  const _component_CheckIcon = _resolveComponent("CheckIcon")
  const _component_StopIcon = _resolveComponent("StopIcon")
  const _component_EditIcon = _resolveComponent("EditIcon")
  const _component_Button = _resolveComponent("Button")
  const _component_BanIcon = _resolveComponent("BanIcon")
  const _component_CardContent = _resolveComponent("CardContent")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    default: _withCtx(() => [
      _createVNode(_component_CardHeader, { class: "bg-gray-100 rounded-t-md" }, {
        default: _withCtx(() => [
          _createVNode(_component_BudgetTableHeaders, { headers: _ctx.categoryHeader }, null, 8, ["headers"])
        ]),
        _: 1
      }),
      _createVNode(_component_CardContent, null, {
        default: _withCtx(() => [
          (!_ctx.data[_ctx.category].length)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _createVNode(_component_WarningIcon, { class: "w-8 h-8" }),
                _createVNode("span", null, _toDisplayString(_ctx.ucFirst(_ctx.category)) + " is empty.", 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data[_ctx.category], (item) => {
            return (_openBlock(), _createBlock("div", {
              class: 
					`grid grid-cols-2 sm:grid-cols-${_ctx.categoryHeader.length} gap-2 text-gray-700 py-4 even:bg-gray-100 items-center text-sm`
				,
              key: item.id
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryHeader, (header, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: ["col-span-1", {
						'pl-2': index === 0,
						'hidden sm:block': !['name', 'actions'].includes(
							header
						),
					}],
                  key: index
                }, [
                  (!header.trim().length)
                    ? (_openBlock(), _createBlock("div", _hoisted_2, [
                        (item.confirmation)
                          ? (_openBlock(), _createBlock("div", _hoisted_3, [
                              _createVNode(_component_CheckIcon, { class: "w-4 h-4 text-white" })
                            ]))
                          : _createCommentVNode("", true),
                        (item.not_track_amount)
                          ? (_openBlock(), _createBlock("div", _hoisted_4, [
                              _createVNode(_component_StopIcon, { class: "w-10 h-10 text-danger" })
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (header === 'actions')
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode(_component_Button, {
                          color: "secondary",
                          fab: "",
                          "onOn-click": $event => (_ctx.showExpenseModal(item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_EditIcon, { class: "w-4 h-4" })
                          ]),
                          _: 1
                        }, 8, ["onOn-click"]),
                        _createVNode(_component_Button, {
                          color: "danger",
                          fab: "",
                          onClick: $event => (_ctx.removeExpense(item.id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BanIcon, { class: "w-4 h-4 text-white" })
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (header !== 'actions' && header.trim().length)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.getExpenseValue(header, item)), 1))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}